import type { ChildDom } from "vanjs-core";
import type { Device } from "../device/device";
import { t } from "../locale";
import { div, input, label } from "./van-tags";

interface Shared {
	device: Device;
}

export const deviceNameField = (shared: Shared): ChildDom => {
	const onInputName = (e: Event): void => {
		if (!(e.target instanceof HTMLInputElement)) return;
		shared.device.Metadata.Name = e.target.value;
	};

	return div(
		{ class: "field" },
		label({ class: "label" }, () => t.name),
		div(
			{ class: "control" },
			input({
				class: "input",
				oninput: onInputName,
				type: "text",
				value: () => shared.device.Metadata.Name,
			}),
		),
	);
};
